import { Module } from 'wrapper6';
import $ from 'jquery';
import { debounce } from '../utils/_debounce';

export default class CoachesSlider extends Module {

	ready() {

        
        const WRAPPERS = document.querySelectorAll('.mtt-coaches-slider');

        if (WRAPPERS.length) {
            for (let i = 0; i < WRAPPERS.length; i++) {
                new CoachSlider( WRAPPERS[i] );
            }
        }
        
    }
}

class CoachSlider {

    constructor(wrapper) {

        this.WRAPPER = wrapper;

        // variables
        this.active_class = 'mtt-coaches-slider__avatar--active';
        this.type = this.WRAPPER.getAttribute('data-type');
        this.shadow_sizes = {
            size_one: 68,
            size_two: 152,
            size_three: 236
        };

        // elements
        this.SWIPER_CONTAINER = this.WRAPPER.querySelector('.swiper-container');
        this.AVATARS = this.WRAPPER.querySelectorAll('.mtt-coaches-slider__avatar');
        this.AVATAR_SHADOW = this.WRAPPER.querySelector('.mtt-coaches-slider__active-shadow');

        // check if avatars is found
        if (!this.AVATARS.length && !this.AVATAR_SHADOW) return;

        // set active avatar
        this.active_avatar = this.AVATARS[0];

        // init slider
        this.init();

        // center shadow 
        this.centerShadow();

        // avatar handler
        this.avatarsHandler();

        // on slide change
        this.onSlideChange();

    }

    init() {

        let slider_options = {};

        if (this.type == 'default') {

            slider_options = {
                speed: 600,
                slidesPerView: 'auto',
                loop: false,
                centeredSlides: true,
                grabCursor: true,
                spaceBetween: 0
            }

        } else {

            slider_options = {
                speed: 600,
                slidesPerView: 1.25,
                slidesPerGroup: 1,
                loop: false,
                centeredSlides: true,
                grabCursor: true,
                spaceBetween: 16,
                slidesOffsetAfter: 0,
                observer: true,
                observeParents: true,
                breakpoints: {
                    350: {
                        centeredSlides: true,
                        slidesPerView: 1.4,
                        spaceBetween: 16,
                    },
                    450: {
                        centeredSlides: true,
                        slidesPerView: 1.6,
                        spaceBetween: 16,
                        slidesPerGroup: 1
                    },
                    650: {
                        centeredSlides: false,
                        slidesPerView: 2,
                        spaceBetween: 24,
                        slidesPerGroup: 2
                    },
                    700: {
                        centeredSlides: false,
                        slidesPerView: 2,
                        spaceBetween: 32,
                        slidesPerGroup: 2
                    },
                    960: {
                        centeredSlides: false,
                        slidesPerView: 3,
                        spaceBetween: 32,
                        slidesPerGroup: 3
                    }
                }
            }

        }

        // init slider
        this.SLIDER = new Swiper( this.SWIPER_CONTAINER, slider_options);

        // set active class on init
        this.setActiveClasses();

        window.addEventListener('resize', debounce(this.setActiveClasses.bind(this), 300));

        // set offset
        this.setGlideOffset();

        window.addEventListener('resize', debounce(this.setGlideOffset.bind(this), 300));

    }

    setActiveClasses() {
        
        if (this.type == 'default') return;

        // hide all classes
        for (let i = 0; i < this.AVATARS.length; i++) {
            this.AVATARS[i].classList.remove( this.active_class );
        }

        // set active class
        if (this.SLIDER.params.slidesPerView == 1) {

            this.AVATARS[this.SLIDER.activeIndex].classList.add( this.active_class );

        } else {

            // if i is between active index and active index + slidesPerView
            for (let i = 0; i < this.AVATARS.length; i++) {
                if (i >= this.SLIDER.activeIndex && i < this.SLIDER.activeIndex + this.SLIDER.params.slidesPerView) {
                    this.AVATARS[i].classList.add( this.active_class );
                }
            }

        }

    }

    setGlideOffset() {

        if (this.type == 'default') return;

        // group count
        let group_count = Math.ceil(this.SLIDER.slides.length / this.SLIDER.params.slidesPerView);

        // maximum slides
        let max_slides = group_count * this.SLIDER.params.slidesPerView;

        // get remaining
        let remaining = max_slides - this.SLIDER.slides.length;

        // get slide width
        const ACTIVE_SLIDE = this.WRAPPER.querySelector('.swiper-slide-active');
        let slide_width = ACTIVE_SLIDE ? ACTIVE_SLIDE.getBoundingClientRect().width : 0;

        // get space between
        let space_between = this.SLIDER.params.spaceBetween;

        // update offset after
        this.SLIDER.params.slidesOffsetAfter = ((slide_width + space_between) * remaining) + 50; // add 50 for error margin

    }

    avatarsHandler() {

        for (let i = 0; i < this.AVATARS.length; i++) {
            
            const AVATAR = this.AVATARS[i];

            AVATAR.addEventListener('click', () => {

                // update current avatar
                this.active_avatar = AVATAR;
                
                // get index
                const INDEX = AVATAR.getAttribute('data-avatar-id');

                // slide to slide
                this.SLIDER.slideTo( INDEX );

                // center active element
                this.centerShadow();

                // set avatar active classes
                this.setActiveClasses();

            });
            
        }

        // center shadow after resize
        window.addEventListener('resize', debounce(this.centerShadow.bind(this), 300));
    }

    centerShadow() {

        if (!this.active_avatar) return;

        let top = this.active_avatar.offsetTop;
        let left = this.active_avatar.offsetLeft;
        left = this.isOdd( document.body.clientWidth ) ? left + 0.5 : left; // add half a pixel when screen width is odd

        this.AVATAR_SHADOW.style.top = top + 'px';
        this.AVATAR_SHADOW.style.left = left + 'px';

        if (this.type == 'default') return;

        if (this.getScreenWidth() >= 650) {

            let remaining = this.SLIDER.slides.length - this.SLIDER.realIndex;
    
            // set avatar shadow width
            this.AVATAR_SHADOW.style.width = this.getShadowWidth(remaining) + 'px';

        } else {
            this.AVATAR_SHADOW.style.width = '';
        }

    }

    getShadowWidth(remaining) {
        if (remaining == 1) {
            return this.shadow_sizes.size_one;
        } else if (remaining == 2 || this.getScreenWidth() <= 959) {
            return this.shadow_sizes.size_two;
        } else {
            return this.shadow_sizes.size_three;
        }
    }

    onSlideChange() {

        this.SLIDER.on('slideChange', () => {

            for (let i = 0; i < this.AVATARS.length; i++) {

                // remove active class
                this.AVATARS[i].classList.remove(this.active_class);

                // set active avatar
                if (this.SLIDER.activeIndex == i) {
                    this.active_avatar = this.AVATARS[i];
                }
            }

            // set active class
            this.active_avatar.classList.add(this.active_class);

            // center shadow
            this.centerShadow();

        });
    }

    isOdd(num) {
        return num % 2;
    }

    getScreenWidth() {
        return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    }
}


// WEBPACK FOOTER //
// ./resources/js/modules/_coaches-slider.js